import React from "react";
import {useEffect, useState} from 'react';
import PluginModal from '../pluginModal.js';
import {Button, Icon, Input} from '@material-ui/core';
import {api} from '../../utility';
import store from 'store';
import * as userActions from '../../actions/authenticationActions';
import {useDispatch} from 'react-redux';
import { useHistory } from "react-router-dom";
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { Tooltip ,Typography,TextField } from "@material-ui/core";
import {FOOTER_TEXTS} from '../../utility';

function ManualLoginPanel(props){

  const dispatch = useDispatch();
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);
  const [tokenString, setTokenString] = useState("");

  const handleClose = () => {
    setModalOpen(false);
  }

  const handleLogin = () => {
    if(tokenString && tokenString != ""){
      const JSONToken = JSON.parse(tokenString);
      const {name,token,email} = JSONToken;
      if(name && token && email) {
        console.log("Setting user", token);
        dispatch(userActions.loginAdThriveUserManually(token, name, email, () => {
          history.push('/choose_site');
          window.AP.tanalytics.track('User Login');
          setModalOpen(false);
        }));
      }
    }
  }

  const Logout = ()=>{
    dispatch(userActions.logoutUser());
    history.push('/login_adthrive');
  }

  return(
    <React.Fragment>
      <Tooltip title={FOOTER_TEXTS.MANUAL_LOGIC_TEXT} arrow style={{marginRight:'0.5rem', padding: '10px'}}>
        <Button onClick={() => { setModalOpen(true); }} style={{color:'#8080808f', float:'right'}}><VpnKeyIcon/></Button>
      </Tooltip>
      <Tooltip title={FOOTER_TEXTS.LOGOUT_TEXT} arrow style={{marginRight:'0.5rem', padding: '10px'}}>
        <Button onClick={Logout} style={{color:'#8080808f', float:'right'}}><ExitToAppIcon/></Button>
      </Tooltip>
      <PluginModal
        open={modalOpen}
        onClose={handleClose}
      >
        <div style={{margin:'0rem auto',display:"flex",flexDirection:"column",padding:20,justifyContent:'space-between'}}>
          <Typography variant="subtitle2" color="primary" style={{textAlign: 'left', color: '#859fbd', float:'left',marginTop:10}}>
            Paste your authentication key below:
          </Typography>
          <TextField onChange={(e)=>{setTokenString(e.target.value)}} fullWidth type="search" variant="filled"/>
          <Button variant="contained" color="primary" onClick={()=>{handleLogin()}} style={{marginTop:10}}>Login</Button>
        </div>
      </PluginModal>
    </React.Fragment>
  );

}

export default ManualLoginPanel;